// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"stats_mainContainer__UZ65B","sectionTitle":"stats_sectionTitle__1Tzmc","dark":"stats_dark__NdGKf","light":"stats_light__AYBRX"};